import FarmerKycEnablePage from "./FarmerKycEnablePage";

export default function FarmerKycEnable() {
  return <FarmerKycEnablePage />;
}
